module.exports = __webpack_public_path__ + "img/kommune-1657.0a129273.svg";